import { render, staticRenderFns } from "./ListaSoftware.vue?vue&type=template&id=232544ae&scoped=true&"
import script from "./ListaSoftware.vue?vue&type=script&lang=js&"
export * from "./ListaSoftware.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "232544ae",
  null
  
)

export default component.exports